module.exports = __webpack_public_path__ + "img/logo_sus.efe6dccc.svg";